import React, { useEffect,useMemo, useState } from 'react';

import { debounce as lodashDebounce } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormInputField from 'components/FormInputField/FormInputField';
import { actions,duck } from 'coupon-common/src/modules/locations';
import { getNormalizedEntity } from 'coupon-common/src/utils';

import styles from './FormAddressAutoCompleteField.module.scss';

const FormAddressAutoCompleteField = ({ form, locations, dispatch, readOnly }) => {
    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        dispatch(actions.getProvinces());
        dispatch(actions.getCities());
        // form.change("country", "Canada");
    }, [dispatch]);

    useEffect(() => {
        if (form.getState().values.province) {
            form.change("country", "Canada");
        }
    }, [form.getState().values.province])

    const fetchAddressSuggestions = async (input) => {
        if (!input) return setSuggestions([]);

        try {
            const res = await fetch(
                `${process.env.REACT_APP_BASE_URL}/users/address-autocomplete/?query=${encodeURIComponent(input)}`
            );
            const data = await res.json();
            setSuggestions(data.predictions || []);
        } catch (err) {
            console.error('Error fetching address suggestions:', err);
        }
    };

    const debouncedFetch = useMemo(() => lodashDebounce(fetchAddressSuggestions, 300), []);

    const fetchPlaceDetails = async (placeId) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/users/place-details/?place_id=${placeId}`
            );
            const data = await response.json();

            if (data) {
                const provincesKey = duck.provincesEntity.key;
                const citiesKey = duck.citiesEntity.key;

                const { entityList: provinceOptions } = getNormalizedEntity(locations, provincesKey);
                const { entityList: cityOptions } = getNormalizedEntity(locations, citiesKey);

                const matchedProvince = provinceOptions.find(
                    (p) => p.name.toLowerCase() === data.province.toLowerCase()
                );
                const matchedCity = cityOptions.find(
                    (c) => c.name.toLowerCase() === data.city.toLowerCase()
                );

                if (matchedProvince) form.change('province', matchedProvince);
                if (matchedCity) form.change('city', matchedCity);
                if (data.postal_code) form.change('postal_code', data.postal_code);
                // if (data.country) form.change('country', data.country);
                form.change("country", data.country || "Canada");
            }
        } catch (err) {
            console.error('Error fetching place details:', err);
        }
    };

    return (
        <>
            <div className={styles.addressWrapper}>
                <FormInputField
                    name="street"
                    label="Business Address"
                    placeholder="123 Main St"
                    autoComplete="off"
                    onChange={(e) => {
                        form.change('street', e.target.value);
                        debouncedFetch(e.target.value);
                    }}
                    disabled={readOnly}

                />

                {suggestions.length > 0 && (
                    <ul className={styles.suggestionsDropdown}>
                        {suggestions.map((s, index) => (
                            <li
                                key={s.place_id || index}
                                onClick={async () => {
                                    form.change('street', s.description);
                                    setSuggestions([]);
                                    await fetchPlaceDetails(s.place_id);
                                }}
                            >
                                {s.description}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            <div className="row">
                <div className={`col-sm-6 ${styles.formGroup}`}>
                    <FormInputField name="city" label="City" disabled valueKey="name" />
                </div>
                <div className={`col-sm-6 ${styles.formGroup}`}>
                    <FormInputField name="province" label="Province" disabled valueKey="name" />
                </div>
                <div className={`col-sm-6 ${styles.formGroup}`}>
                    <FormInputField name="postal_code" label="Postal Code" disabled />
                </div>
                <div className={`col-sm-6 ${styles.formGroup}`}>
                    <FormInputField name="country" label="Country" disabled />
                </div>
            </div>
        </>
    );
};

FormAddressAutoCompleteField.propTypes = {
    form: PropTypes.object.isRequired,
    locations: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => ({
    locations: state.locations,
});

export default connect(mapStateToProps)(FormAddressAutoCompleteField);
// export default FormAddressAutoCompleteField;
